/**
 * 数据类型
 */
export const CSM_DATA_TYPE = 'csmDataType'

/**
 * 流失去向
 */
export const CSM_LOSS_DIRECTION = 'csmLossDirection'

/**
 * 流失原因
 */
export const CSM_LOSS_REASON = 'csmLossReason'

/**
 * 维修类别
 */
export const CSM_MAINTAIN_CATEGORY = 'csmPortalMaintainCategory'

/**
 * 购车门店
 */
export const CSM_BOUGHT_STORE = 'csmBoughtStore'

/**
 * 车辆状态
 */
export const CSM_VEHICLE_STATUS = 'csmVehicleStatus'

/**
 * 用车地点
 */
export const CSM_CAR_LOCATION = 'csmCarLocation'

/**
 * 通话状态
 */
export const CSM_CALL_STATUS = 'csmCallStatus'

/**
 * 回店可能性
 */
export const CSM_BACK_STORE_POSSIBILITY = 'csmBackStorePossibility'

/**
 * 客户状态
 */
export const CSM_CUSTOMER_STATUS = 'csmCustomerStatus'

/**
 * 邀约状态
 */
export const CSM_INVITATION_STATUS = 'csmInvitationStatus'

/**
 * 进店状态
 */
export const CSM_ENTER_STORE = 'csmEnterStore'

/**
 * 状态
 */
export const CSM_INVITATION_REQ_EXT_STATUS = 'csmInvitationReqExtStatus'

/**
 * 申请人
 */
export const CSM_INVITATION_REQ_REQUESTOR = 'csmInvitationReqRequestor'

/**
 * 活动类别
 */
export const CSM_ACTIVITY_CATEGORY = 'csmActivityCategory'

/**
 * 邀约类别
 */
export const CSM_INVITATION_CATEGORY = 'csmInvitationCategory'

/**
 * 预约状态
 */
export const CSM_RESERVATION_STATUS = 'csmReservationStatus'

/**
 * 是否到店
 */
export const CSM_IS_ARRIVED_STORE = 'csmIsArrivedStore'

/**
 * 来源
 */
export const CSM_RESERVATION_CHANNEL = 'csmReservationChannel'

/**
 * 无效原因
 */
export const CSM_INVALID_REASON = 'csmInvalidReason'

/**
 * 预约时间
 */
export const CSM_RESERVATION_TIME = 'csmReservationTime'

/**
 * 操作类型
 */
export const CSM_OPERATION_TYPE = 'csmOperationType'

/**
 * 回访类型
 */
export const CSM_VISIT_CATEGORY = 'csmVisitCategory'

/**
 * 电话状态
 */
export const CSM_PHONE_STATUS = 'csmPhoneStatus'

/**
 * 车辆产地
 */
export const CSM_VEHICLE_ORIGIN = 'csmVehicleOrigin'

/**
 * Portal维修类别
 */
export const CSM_PORTAL_MAINTAIN_CATEGORY = 'csmPortalMaintainCategory'

/**
 * 邀约记录数据来源
 */
export const CSM_INVITATION_DATA_SOURCE = 'csmInvitationDataSource'

/**
 * 车辆维修记录来源类别
 */
export const CSM_MAINTENANCE_SOURCE_TYPE = 'csmMaintenanceSourceType'

/**
 * 车型名称
 */
export const CSM_VEHICLE_NAME = 'csmVehicleName'

/**
 * 有效沟通
 */
export const CSM_CALL_STATUS_VALID_INTERVIEW = 1000

/**
 * 无效沟通
 */
export const CSM_CALL_STATUS_INVALID_INTERVIEW = 1003

/**
 * 未接通
 */
export const CSM_CALL_STATUS_NOT_CONTACTED = 1005

/**
 * 未拨打
 */
export const CSM_CALL_STATUS_NOT_DIALED = 1004
/**
 * 修理厂
 */
export const CSM_LOSS_DIRECTION_REPAIR_DEPOT = 1006

/**
 * 沈阳-奥通
 */
export const CSM_LOSS_DIRECTION_SY_AOTONG = 1001

/**
 * 沈阳-奥尊
 */
export const CSM_LOSS_DIRECTION_SY_AOZUN = 1007
/**
 * 沈阳-新龙业
 */
export const CSM_LOSS_DIRECTION_SY_XLY = 1008
/**
 * 沈阳-和泰
 */
export const CSM_LOSS_DIRECTION_SY_HETAI = 1009
/**
 * 沈阳-业乔
 */
export const CSM_LOSS_DIRECTION_SY_YEQIAO = 1010
/**
 * 同城他店
 */
export const CSM_LOSS_DIRECTION_OTHER_SHOP = 1002
/**
 * 本省他市
 */
export const CSM_LOSS_DIRECTION_BS_OTHER_CITY = 1003
/**
 * 外省外市
 */
export const CSM_LOSS_DIRECTION_WS_OTHER_CITY = 1005

/**
 * 呼出
 */
export const CALL_OUT = 1000

/**
 * 呼入
 */
export const CALL_IN = 1100

/**
 * 上门地点
 */
export const CSM_DOOR_TO_DOOR_LOCATION = 'csmDoorToDoorLocation'

/**
 * 是否到店-已到店
 */
export const TO_SHOP = 1000

/**
 * 是否到店-未到店
 */
export const NO_TO_SHOP = 1100

/**
 * 日常待访
 */
export const DAILY_TO_BE_INTERVIEWED = 1000

/**
 * 活动待访
 */
export const ACTIVITY_TO_BE_INTERVIEWED = 1100

/**
 * 活动类别-召回邀约
 */
export const ACTIVITY_RECALL_INTERVIEWED = 1004

/**
 * 活动类别-流失邀约
 */
export const ACTIVITY_LOSS_INTERVIEWED = 1005

/**
 * 活动类别-行动邀约
 */
export const ACTIVITY_ACTION_INTERVIEWED = 1006

/**
 * 活动类别-活动邀约
 */
export const ACTIVITY_ACTIVITY_INTERVIEWED = 1007
/**
 * 维修类别-保养
 */
export const MAINTAIN_2 = '2'

/**
 * 维修类别-小修
 */
export const MAINTAIN_3 = '3'

/**
 * 维修类别-事故
 */
export const MAINTAIN_5 = '5'

/**
 * 维修类别-事故
 */
export const MAINTAIN_1 = '1'

/**
 * 已邀约
 */
export const INVITED_STATE = 1000

/**
 * 未邀约
 */
export const NOT_INVITATION_STATE = 1100

/**
 * 接触频次
 */
export const IIM_INVITATION_ROUNDS = 'iimInvitationRounds'

/**
 * 保险险种
 */
export const IIM_INSURANCE = 'iimInsurance'

/**
 * 机动车交通事故责任强制保险单
 */
export const INSURANCE_TYPE_FORCE_CODE = 1000

/**
 * 机动车商业保险单
 */
export const INSURANCE_TYPE_BUSINESS_CODE = 1010

/**
 * 子险种类别主险
 */
export const IIM_SON_INSURANCE_MAIN = 'iimSonInsuranceMain'

/**
 * 子险种类别附加险
 */
export const IIM_SON_INSURANCE_ATTACH = 'iimSonInsuranceAttach'

/**
 * 商业子险种类别-主险
 */
export const IIM_SUBCLASS_MAIN_INSURANCE_TYPE_BUSINESS_CODE = 2200

/**
 * 商业子险种类别-附加险
 */
export const IIM_SUBCLASS_ATTACH_INSURANCE_TYPE_BUSINESS_CODE = 2201

/**
 * 保险公司
 */
export const IIM_INSURANCE_COMPANY = 'iimInsuranceCompany'

/**
 * 续保专员
 */
export const STAFF = 'staff'

/**
 * 客户状态（客户关系状态）
 */
export const IIM_CUSTOMER_RELATION = 'iimCustomerRelation'

/**
 * 通话状态
 */
export const IIM_CALL_STATUS = 'iimCallStatus'

/**
 * 邀约状态
 */
export const IIM_RENEWAL_OF_INSURANCE_STATUS = 'iimRenewalOfInsuranceStatus'

/**
 * 续保用车地点
 */
export const IIM_CARLOCATION = 'iimCarLocation'

/**
 * 邀约状态
 */
export const IIM_INVITATION_STATUS = 'iimInvitationStatus'

/**
 * 客户类别
 */
export const IIM_CUSTOMER_TYPE = 'iimCustomerType'

/**
 * 续保车型名称
 */
export const IIM_VEHICLE_NAME = 'iimVehicleName'

/**
 * 续保状态
 */
export const IIM_CALL_STATUS_INSURANCE_STATUS = 'iimCallStatusInsuranceStatus'

/**
 * 续保客户状态 - 放弃
 */
export const RENEWAL_OF_INSURANCE_ABANDON_STATE = 1010

/**
 * 续保客户状态 - 废弃
 */
export const RENEWAL_OF_INSURANCE_DISCARD_STATE = 1020

/**
 * 续保客户状态 - 正常
 */
export const RENEWAL_OF_INSURANCE_NORMAL_STATE = 1000

/**
 * 续保通话状态 - 有效沟通
 */
export const RENEWAL_OF_INSURANCE_EFFECTIVE_COMMUNICATION = 1000

/**
 * 续保通话状态 - 未接通
 */
export const RENEWAL_OF_INSURANCE_NOT_INTERVIEWED = 1001

/**
 * 续保通话状态 - 无效电话
 */
export const RENEWAL_OF_INSURANCE_INVALID_CALL = 1002

/**
 * 续保通话状态 - 无效沟通
 */
export const RENEWAL_OF_INSURANCE_INVALID_INTERVIEW = 1003

/**
 * 续保通话状态 - 未拨打
 */
export const RENEWAL_OF_INSURANCE_NOT_DIALED = 1004

/**
 * 续保通话状态 - 延时邀约
 */
export const RENEWAL_OF_INSURANCE_DELAY_INSURANCE = 1005

/**
 * 续保邀约状态 - 跟踪
 */
export const RENEWAL_OF_INSURANCE_CUSTOMER_RELATION_TRACK = 1000

/**
 * 续保邀约状态 - 已续保
 */
export const RENEWAL_OF_INSURANCE_CUSTOMER_RELATION_SUCCESS = 1100

/**
 * 续保邀约状态 - 战败
 */
export const RENEWAL_OF_INSURANCE_CUSTOMER_RELATION_DEFEATED = 1200

/**
 * 续保接触频次 - 首次接触
 */
export const INVITATION_ROUNDS_FIRST = 1000

/**
 * 活动状态- 已创建
 */
export const ACTIVITY_STATE_CREATED = 1001

/**
 * 活动状态- 进行中
 */
export const ACTIVITY_STATE_STARTING = 1002

/**
 * 活动状态- 已终止
 */
export const ACTIVITY_STATE_STOPED = 1003

/**
 * 活动状态- 已完成
 */
export const ACTIVITY_STATE_FINISHED = 1004

/**
 * 营销活动实例状态
 */
export const MARKETING_ACTIVITY_STATE = 'demoMarketingActivityStatus'

/**
 * 营销推荐计算周期
 */
export const MARKETING_ACTIVITY_CALCULATION_CYCLE = 'demoSuggestMarketingActivityCalculationCycle'

/**
 * 营销活动类别
 */
export const MARKETING_ACTIVITY_TYPE = 'csmMarketingActivityCategory'

/**
 * 邀约详情-提醒类别（提醒为保养）
 */
export const REMIND = 1000

/**
 * 邀约详情-自设回访（可选所有类型的维修类别）
 */
export const SELF_REMIND_TIME = 1200

/**
 * 待访事项-活动车辆状态（车辆状态中部分）
 */
export const DEMO_ACTIVITY_VEHICLE_STATUS = 'demoActivityVehicleStatus'

/**
 * 待访事项-日常车辆状态（车辆状态中部分）
 */
export const DEMO_DAILY_VEHICLE_STATUS = 'demoDailyVehicleStatus'

/**
 * 待访事项-日常维修类别（维修类别中部分）
 */
export const DEMO_DAILY_MAINTAIN_CATEGORY = 'demoDailyMaintainCategory'

/**
 * 待访事项-活动车辆状态（csm活动车辆状态）
 */
export const CSM_ACTIVITY_VEHICLE_STATUS = 'csmActivityVehicleStatus'
/**
 * 字典类型
 */
export const DICTIONAY_TYPE = 1001

/**
 * 布尔类型
 */
export const BOOLEAN_TYPE = 1004

/**
 * 员工类型
 */
export const EMPLOYEE_TYPE = 1006

/**
 * 销售类型
 */
export const CSM_PACKAGE_SALE_TYPE = 'csmPackageSaleType'

/**
 * 备件状态
 */
export const CSM_PARTS_STATUS = 'csmPartsStatus'

/**
 * 年度任务名称
 */
export const CSM_TASK_NAME = 'csmTaskName'

/**
 * 客户意见
 */
export const CSR_CUSTOMER_OPINION = 'csrCustomerOpinion'

/**
 * 精品活动车辆状态
 */
export const CSM_BOUTIQUE_ACTIVITY_VEHICLE_STATUS = 'csmBoutiqueActivityVehicleStatus'

/**
 * 精品活动进店状态
 */
export const CSM_BOUTIQUE_ENTER_STORE = 'csmBoutiqueEnterStore'

/**
 * 精品活动类别
 */
export const CSM_BOUTIQUE_TASK_TYPE = 1300

/**
 * 精品活动进店状态 --成功
 */
export const CSM_BOUTIQUE_ENTER_STORE_SUCCESS = 1000

/**
 * 精品活动进店状态 --失败
 */
export const CSM_BOUTIQUE_ENTER_STORE_FAILURE = 1200

/**
 * 精品活动车辆状态 --预定
 */
export const CSM_BOUTIQUE_ACTIVITY_PREORDAIN = 1017

/**
 * 活动状态-进行中
 */
export const INVITATION_PROCESSING = 1000

/**
 * 活动状态-已结束
 */
export const INVITATION_FINISHED = 1100

/**
 * 活动状态-终止
 */
export const INVITATION_TERMINATED = 1300

/**
 * 活动类别-售后
 */
export const ACTIVITY_CATEGORY_AFTER_SALE = 1004

/**
 * 活动类别-精品
 */
export const ACTIVITY_CATEGORY_BOUTIQUE = 1005

/**
 * 车龄车型统计-车型
 */
export const CAR_MODULE = 209

/**
 * 车龄车型统计-车龄
 */
export const CAR_YEAR = 235

/**
 * 执行角色-客服专员
 */
export const CUSTOMER_SERVICE_EXECUTIVE = 2018

/**
 * 战败原因
 */
export const REASON_OF_FAILURE = 'csmReasonsForDefeatInBoutiqueActivities'

/**
 * 精品活动沟通状态-跟踪
 */
export const BOUTIQUE_ACTIVITY_TRACK = 1016

/**
 * 精品活动沟通状态-预定
 */
export const BOUTIQUE_ACTIVITY_PREORDAIN = 1017

/**
 * 精品活动沟通状态-战败
 */
export const BOUTIQUE_ACTIVITY_DEFEATED = 1018

/**
 * 二手车-商机类型
 */
export const COMMERCIAL_OPPORTUNITY_TYPE = 'uctCommercialOpportunityType'

/**
 * 二手车-商机类型-换购
 */
export const REDEMPTION = 1000

/**
 * 二手车-商机类型-收购
 */
export const ACQUISITION = 2000

/**
 * 二手车-商机类型-售车
 */
export const CAR_SALES = 3000

/**
 * 二手车-商机状态
 */
export const COMMERCIAL_OPPORTUNITY_STATUS = 'uctCommercialOpportunityStatus'

/**
 * 二手车-商机状态-待确认
 */
export const TO_BE_CONFIRMED = 1000
export const CONFIRMED = 1001

/**
 * 二手车-商机状态-有效
 */
export const EFFECTIVE = 1002

/**
 * 二手车-商机状态-无效
 */
export const INVALID = 1003

/**
 * 二手车-商机来源
 */
export const COMMERCIAL_OPPORTUNITY_SOURCE = 'uctCommercialOpportunitySource'

/**
 * 二手车-商机来源-售后
 */
export const AFTER_SALE = 1000

/**
 * 二手车-商机来源-展厅
 */
export const SHOWROOM = 2000

/**
 * 二手车-商机来源-网络
 */
export const THE_INTERNET = 3000

/**
 * 二手车-商机来源-社会
 */
export const SOCIETY = 4000

/**
 * 二手车-商机阶段
 */
export const CARRIED_OUT_STATUS = 'uctCarriedOutStatus'
/**
 * 二手车-商机阶段-成单
 */
export const CARRIED_OUT_STATUS_SUCCESS = 4000
/**
 * 二手车-商机阶段-战败
 */
export const CARRIED_OUT_STATUS_FAIL = 5000

/**
 * 二手车-车身颜色
 */
export const CURRENT_THE_COLOR_OF_CAR = 'uctCurrentTheColorOfCar'

/**
 * 二手车-燃油类型
 */
export const FUEL_TYPE = 'uctFuelType'

/**
 * 二手车-排放标准
 */
export const CURRENT_EMISSION_STANDARDS = 'uctCurrentEmissionStandards'

/**
 * 二手车-驱动方式
 */
export const CURRENT_DRIVING_METHOD = 'uctCurrentDrivingMethod'

/**
 * 二手车-执行状态
 */
export const OPPORTUNITY_EXECUTION_STATUS = 'uctOpportunityExecutionStatus'

/**
 * 二手车-线索状态
 */
export const CLUE_STATUS = 'uctClueStatus'
/**
 * 二手车-线索状态-跟踪
 */
export const TRACK = 1000
/**
 * 二手车-线索状态-成功
 */
export const SUCCESS = 2000
/**
 * 二手车-线索状态-战败
 */
export const DEFEATED = 3000

/**
 * 二手车-战败原因
 */
export const REASON_FOR_FAILURE = 'uctReasonForFailure'
export const CAR_OWNERS_DO_NOT_WANT_TO_SELL = 1000
export const CAR_SOLD = 2000

/**
 * 二手车-通话状态
 */
export const UCT_CALL_STATUS = 'uctCallStatus'

/**
 * 二手车-变速箱
 */
export const CEARBOX = 'uctCearbox'

/**
 * 续保战败原因
 */
export const CAUSE_OF_DEFEAT = 'causeOfDefeat'

/**
 * 续保客户管理-购车日期按月查询条件
 */
export const DATE_OF_PURCHASE_BY_MONTH = 'dateOfPurchaseByMonth'

/**
 * 开单状态
 */
export const CSM_BILLING_STATUS = 'csmBillingStatus'

/**
 * 认证方式
 */
export const MEMBER_VERIFICATION_MANNER = 'memberVerificationManner'

/**
 * 卡券类型
 */
export const COUPON_CUPON_TYPE = 'couponCuponType'

/**
 * 卡券定义状态
 */
export const COUPON_DEFINITION_STATUS = 'couponDefinitionStatus'

/**
 * 卡券定义状态-启用
 */
export const COUPON_START = 1000

/**
 * 卡券定义状态-停用
 */
export const COUPON_STOP = 2000

/**
 * 卡券到期类型
 */
export const COUPON_EXPIRES_TYPE = 'couponExpiresType'

/**
 * 卡券到期类型-领取后时间长度有效
 */
export const THE_LENGTH_OF_TIME_AFTER_RECEIPT_IS_VALID = 2000

/**
 * 认证状态（审核状态）
 */
export const MEMBER_VERIFICATION_STATUS = 'memberVerificationStatus'

/**
 * 认证状态（审核状态）-已通过
 */
export const MEMBER_VERIFICATION_STATUS_PASSED = 3000

/**
 * 卡券状态-待审批
 */
export const PENDING = 2000

/**
 * 卡券状态-已通过
 */
export const PASSED = 3000

/**
 * 卡券状态-驳回
 */
export const TURN_DOWN = 4000

/**
 * 购买类型
 */
export const APPLICATION_TYPE = 'applicationType'

/**
 * 所属部门
 */
export const DEPARTMENT = 'department'

/**
 * 核销方式
 */
export const CANCELLATION_AFTER_VERIFICATION_TYPE = 'cancellationAfterVerificationType'

/**
 * 会员来源
 */
export const MEMBER_MEMBER_SOURCE = 'memberMemberSource'

/**
 * 卡券使用状态
 */
export const COUPON_USE_STATUS = 'couponUseStatus'

/**
 * 卡券使用状态-未核销
 */
export const COUPON_USE_STATUS_UNWRITTEN = 1000

/**
 * 卡券使用状态-已核销
 */
export const COUPON_USE_STATUS_WRITTEN_OFF = 2000

/**
 * 卡券使用状态-已过期
 */
export const COUPON_USE_STATUS_EXPIRED = 3000

export const MEMBER_CAR_ATTRIBUTION = 'carAttribution'

/**
 * 核销方式-卡券核销
 */
export const COUPON_CANCELLATION = 1000

/**
 * 核销方式-卡券与现金核销
 */
export const COUPON_AND_SALES_AMOUNT_CANCELLATION = 2000

/**
 * 卡券发放审批状态-未审批
 */
export const COUPON_GIVE_OUT_NOT_APPROVED = 1000

/**
 * 卡券发放审批状态-待审批
 */
export const COUPON_GIVE_OUT_NOT_PENDING = 2000

/**
 * 卡券发放审批状态-已通过
 */
export const COUPON_GIVE_OUT_PASSED = 3000

/**
 * 卡券发放审批状态-已驳回
 */
export const COUPON_GIVE_OUT_NOT_TURN_DOWN = 4000

/**
 * 卡券发放审批状态-作废
 */
export const COUPON_GIVE_OUT_NOT_BECOME_INVALID = 5000

/**
 * 我的积分-变更类型
 */
export const MY_POINTS_TYPE = 'memberStoredValueCardTypesOfStoredValueChanges'

/**
 * 兑换记录-订单状态
 */
export const ORDER_STATUS = 'pmallPointsRedeemOrderStatus'

/**
 * 消费记录-支付方式
 */
export const PAY_TYPE = 'pmallPayTypeStatus'

/**
 * 消费记录-储值卡类型
 */
export const MY_CARD_TYPE = 'storedValueCardDefinitionId'

/**
 * 我的车辆-车辆品牌
 */
export const MY_CAR_BRANDS = 'memberVehicleBrands'

/**
 * 我的车辆-车辆类型
 */
export const MY_CAR_TYPE_NAME = 'memberVehicleName'

/**
 * 我的订单-订单状态
 */
export const MY_ORDER_STATUS = 'pmallOnlineStoreOrderComprehensiveStatus'
/**
 * 积分商城-会员信息-婚姻状态
 */
export const MARITAL_STATUS = 'maritalStatus'
/**
 * 积分商城-会员信息-职业
 */
export const TYPE_OCCUPATION = 'occupation'
/**
 * 积分商城-会员信息-月收入
 */
export const TYPE_MONTHLY_INCOME = 'monthlyIncome'
/**
 * 积分商城-会员信息-兴趣爱好
 */
export const TYPE_HOBBY = 'hobby'
/**
 * 积分商城-会员信息-车辆用途
 */
export const TYPE_VEHICLE_USE = 'vehicleUse'
/**
 * 积分商城-门店信息
 */
export const DEPARTMENT_INFO = 'sysDepartment'
/**
 * 判断卡劵显示金额权限Y/N
 */
export const COUPON_SHOW_AMOUNT = 'coupon.show-amount'



// WEBPACK FOOTER //
// ./src/constants/DictionaryConstants.js